// extracted by mini-css-extract-plugin
export default {"wrapper":"SuccessToast_wrapper__s5ZEA"};